(function($, window, document, s, undefined) {

  var bannerWidth = 850;  // the width of banners in pixels
  var winWidth = 0;

  // BANNERS CAROUSEL VARS

  var $bannersCarousel = null;


  // PRODUCTS CAROUSELS VARS

  var $productsCarousel = null;
  var $groupsCarousel = null;
  var $childrensCarousel = null;
  var productsCarouselSlidesToShow = 0;

  // navigation links
  var $recommendedLink = $('.product-group-link.recommended-link');
  var $offersLink = $('.product-group-link.offers-link');
  var $classicsLink = $('.product-group-link.classics-link');

  // number of the slide that corresponds to the beginning of product offers
  var offersIndex = parseInt($offersLink.attr('href'), 10);
  // number of the slide that corresponds to the beginning of classic products
  var classicsIndex = parseInt($classicsLink.attr('href'), 10);


  /*
  * Initializes the banners carousel.
  */
  var initBannersCarousel = function initBannersCarousel(initialSlide) {
    var dynamicPadding = 0;
    $bannersCarousel = $('.banners-carousel');

    if (!initialSlide) {
      initialSlide = 0;
    }

    // dynamicPadding = Math.max(Math.floor((winWidth - bannerWidth)/2 - 50), -50);

    $bannersCarousel.slick({
      // centerMode: true,
      arrows: false,
      slidesToShow: 1,
      // centerPadding: '50px',
      dots: true,
      initialSlide: initialSlide,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 850,
          settings: {
            centerMode: false,
            centerPadding: '0px'
          }
        },
        {
          breakpoint: 860,
          settings: {
            centerMode: true,
            centerPadding: '10px'
          }
        },
        {
          breakpoint: 940,
          settings: {
            centerMode: true,
            centerPadding: '25px'
          }
        },
        {
          breakpoint: 1000,
          settings: {
            centerMode: true,
            centerPadding: '40px'
          }
        },
        {
          breakpoint: 1040,
          settings: {
            centerMode: true,
            centerPadding: '50px'
          }
        },
        {
          breakpoint: 1100,
          settings: {
            centerMode: true,
            centerPadding: '100px'
          }
        },
        {
          breakpoint: 1250,
          settings: {
            centerMode: true,
            centerPadding: '150px'
          }
        },
        {
          breakpoint: 1375,
          settings: {
            centerMode: true,
            centerPadding: '200px'
          }
        },
        {
          breakpoint: 1500,
          settings: {
            centerMode: true,
            centerPadding: '250px'
          }
        },
        {
          breakpoint: 1700,
          settings: {
            centerMode: true,
            centerPadding: '350px'
          }
        },
        {
          breakpoint: 1800,
          settings: {
            centerMode: true,
            centerPadding: '400px'
          }
        },
        {
          breakpoint: 1900,
          settings: {
            centerMode: true,
            centerPadding: '450px'
          }
        },
      ]
    });
  };


  /*
  * Initializes the products carousels and attaches the appropriate event
  * listeners.
  */

  var initProductsCarousel = function initProductsCarousel() {
    var opts = null;
    var productsCarouselHelper = {
      w480: 1,
      w768: 2,
      w992: 4,
      w1200: 5,
    };
    var productsCarouselSlidesToShow = 0;

    $productsCarousel = $('.products-carousel');
    $groupsCarousel = $('.product-groups-carousel');
    $childrensCarousel = $('.childrens-books-carousel');
    $recommendedLink = $('.product-group-link.recommended-link');
    $offersLink = $('.product-group-link.offers-link');
    $classicsLink = $('.product-group-link.classics-link');

    // This is done so that the values used to initialize slick with are the
    // ones corresponding to the responsive settings.
    productsCarouselSlidesNumber = 1;
    for (var i in productsCarouselHelper) {
      if (parseInt(i.substring(1), 10) > winWidth) {
        break;
      }
      productsCarouselSlidesNumber = productsCarouselHelper[i];
    }


    opts = {
      infinite: false,
      swipeToSlide: true,
      arrows: true,
      initialSlide: 0,
      variableWidth: true,
      mobileFirst: true,
      cssEase: 'ease-out',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            // slidesToShow: productsCarouselHelper.w1200,
            slidesToScroll: productsCarouselHelper.w1200
          }
        },
        {
          breakpoint: 992,
          settings: {
            // slidesToShow: productsCarouselHelper.w992,
            slidesToScroll: productsCarouselHelper.w992
          }
        },
        {
          breakpoint: 768,
          settings: {
            // slidesToShow: productsCarouselHelper.w768,
            slidesToScroll: productsCarouselHelper.w768,
          }
        },
        {
          breakpoint: 480,
          settings: {
            // slidesToShow: productsCarouselHelper.w480,
            slidesToScroll: productsCarouselHelper.w480
          }
        },
      ]
    };

    $.extend(opts, {appendArrows: '.section-product-groups'});
    $groupsCarousel.slick(opts);

    $.extend(opts, {appendArrows: '.section-childrens-books'});
    $childrensCarousel.slick(opts);

    indicateGroupsActiveLink(2);

    $groupsCarousel.on('afterChange', function groupsCarouselChange(e, currentSlide){
      var currentIndex = currentSlide.currentSlide;
      indicateGroupsActiveLink(currentIndex);
    });

    $groupsCarousel.on('afterChange', function groupsCarouselChange(e, currentSlide){
      var currentIndex = currentSlide.currentSlide;
      indicateGroupsActiveLink(currentIndex);
    });

    $('.product-group-link').on('click', function groupLinkClick(e){
      e.preventDefault();
      var $this = $(e.currentTarget);

      resetGroupLinkClasses();
      $groupsCarousel.slick('slickGoTo', $this.attr('href'));
      $this.addClass('active');
    });

  };


  /*
  * Adds the "active" class to the appropriate navigation link of the carousel.
  */
  var indicateGroupsActiveLink = function indicateGroupsActiveLink(currentIndex) {
    if (currentIndex >= classicsIndex) {
      resetGroupLinkClasses();
      $classicsLink.addClass('active');
    } else if (currentIndex >= offersIndex) {
      resetGroupLinkClasses();
      $offersLink.addClass('active');
    } else if (currentIndex < offersIndex) {
      resetGroupLinkClasses();
      $recommendedLink.addClass('active');
    }
  };

  /*
  * Removes the "active" class from all navigation links of the groups carousel.
  */
  var resetGroupLinkClasses = function resetGroupLinkClasses() {
    $('.product-group-link.active').removeClass('active');
  };

  /**
  * Destroys and reinitializes slick carousels.
  * TODO: This does not work correctly
  */
  // var reInitCarousels = function reInitCarousels() {
  //   var currentSlide = 0;
  //   var currentSlide2 = 0;
  //
  //   winWidth = s.$win.width();
  //
  //   currentSlide = $bannersCarousel.slick('slickCurrentSlide');
  //   $bannersCarousel.slick('destroy');
  //   initBannersCarousel(currentSlide);
  //
  //   currentSlide = $groupsCarousel.slick('slickCurrentSlide');
  //   currentSlide2 = $childrensCarousel.slick('slickCurrentSlide');
  //   $productsCarousel.slick('destroy');
  //   initProductsCarousel(currentSlide, currentSlide2);
  // };


  var initReviewsCarousel = function initReviewsCarousel() {
    $('.reviews-carousel')
      .on('init', adjustReviewCarouselHeights)
      .slick({
        slidesToShow: 1,
        dots: true,
        arrows: false,
        rows: 1
      });
  };


  var adjustReviewCarouselHeights = function adjustReviewCarouselHeights(){
    var offset = Math.floor($('.reviews-section .slick-track').outerHeight()/2);

    $('.reviews-carousel .review').each(function (){
      var $this = $(this);

      $this.css('padding-top', Math.floor(offset - $this.outerHeight()/2) + 'px');
    });
  };

  var checkForCarousels = function checkForReadMoreLink() {
    if (document.body.id === 'body-home') {
      winWidth = s.$win.width();

      initBannersCarousel();
      initProductsCarousel();
      // s.callOnResize(reInitCarousels);
    } else if (document.body.id === 'body-product-detail') {
      initReviewsCarousel();
      // s.callOnResize(reInitCarousels);
    }
  };

  // Commented the following because of a bug where
  // the carousels wouldn't load if the images had already loaded
  // imagesLoaded(document, checkForCarousels);
  checkForCarousels();

})(jQuery, this, this.document, window.s);
